export default __webpack_public_path__ + "static/media/sg-bg.c46950d8.png";